import axios from "axios";
import config from "../../config/config";
axios.defaults.headers.post["Content-Type"] =
  "application/x-www-form-urlencoded";

const url = config.IP_ADDRESS;

const GetIPAddress = () => {
  return async (dispatch) => {
    try {
      const response = await axios.get(url);
      dispatch({
        type: "IP_ADDRESS",
        payload: response,
      });
    } catch (error) {
      console.log(error);
    }
  };
};

export default GetIPAddress;
